module.exports = __webpack_public_path__ + "img/img_58.11e06e18.png";